import { render, staticRenderFns } from "./DutyManagementConfig.vue?vue&type=template&id=76d2bade"
import script from "./DutyManagementConfig.vue?vue&type=script&lang=js"
export * from "./DutyManagementConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports